import { LinkPage } from '@features/blockit-link/components/LinkPage';
import { linkPageLoader } from '@features/blockit-link/linkPageLoader';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/link/$namespace/$linkId/{-$meetingId}')({
  loader: ({ params, location }) => linkPageLoader({ meetingId: params.meetingId, searchStr: location.searchStr }),
  component: LinkPage,
});
